import script from "./InsuranceExportBlankDetailsComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./InsuranceExportBlankDetailsComponent.vue?vue&type=script&setup=true&lang=ts"

import "./InsuranceExportBlankDetailsComponent.vue?vue&type=style&index=0&id=a91cffe2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a91cffe2"]])

export default __exports__